import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import Login from './pages/login';
import Navbar from './components/navbar';
import Topbar from './components/topbar';
import Users from './pages/user';
import Admins from './pages/admin';
import Transaction from './pages/transaction';
import Gateway from './pages/gateway';
import Category from './pages/category';
import Layout from './pages/layout';
import { useEffect, useState } from 'react';
import Complaints from './pages/complaints';
import Verified from './pages/verified';
import Cost from './pages/cost';

function App() {
  const [small, setSmall] = useState(true)
  const [isNavShow, setNavShow] = useState(true)
  const checkDocumentWidth = () => {
      if (document.documentElement.clientWidth > 600) {
        setSmall(false);
      } else {
        setSmall(true);
      }
    };
  
    useEffect(() => {
      // Initial check when the component mounts
      checkDocumentWidth();
  
      // Listen for window resize events
      window.addEventListener('resize', checkDocumentWidth);
  
      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener('resize', checkDocumentWidth);
      };
    }, []);

  return (
    <div className="App">
      <BrowserRouter>
      {isNavShow && <Navbar />}
      {isNavShow && <Topbar />}
      <div className={(small) ? 'margin-tp' : 'h'}>
      <Routes>
        <Route path='/dashboard' element={<Dashboard setNavShow={setNavShow}/>} />
        <Route path='/' element={<Login setNavShow={setNavShow}/>} />
        <Route path='/complaints' element={<Complaints setNavShow={setNavShow}/>} />
        <Route path='/users' element={<Users setNavShow={setNavShow}/>}/>
        <Route path='/verified' element={<Verified setNavShow={setNavShow}/>}/>
        <Route path='/admin' element={<Admins setNavShow={setNavShow}/>}/>
        <Route path='/transaction' element={<Transaction setNavShow={setNavShow}/>}/>
        <Route path='/gateway' element={<Gateway setNavShow={setNavShow}/>} />
        <Route path='/cost' element={<Cost setNavShow={setNavShow}/>}/>
        <Route path='/country' element={<Category setNavShow={setNavShow}/>}/>
        <Route path='/sms' element={<Layout setNavShow={setNavShow}/>}/>
      </Routes>
        </div>
      
      </BrowserRouter>
    </div>
  );
}

export default App;
